import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("slideShowCard4", component(opts));
  editor.BlockManager.add("slideShowCard4", block(opts));
};